import React, { useState, useEffect, useRef } from 'react';
import './BackgroundVideo.scss';

interface BackgroundVideoProps {
  currentSection: string;
}

const BackgroundVideo: React.FC<BackgroundVideoProps> = ({ currentSection }) => {
  const [currentVideo, setCurrentVideo] = useState('Shadow OP.mp4');
  const [isLoading, setIsLoading] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const videoMap: { [key: string]: string } = {
    'hero': 'Shadow OP.mp4',
    'features': 'Product header video.mp4',
    'track-anything': 'About - product video.mp4',
    'how-it-works': 'Intercut video.mp4',
    'starlink-tracker': 'About - shop tracker video.mp4',
    'dual-protection': 'Movement Mode.mp4',
    'product-details': 'About - shop tracker video.mp4',
    'videos': 'About bike video.mp4',
    'pricing': 'Landing page footer video.mp4',
    'default': 'Shadow OP.mp4'
  };

  useEffect(() => {
    const newVideo = videoMap[currentSection] || videoMap['default'];
    if (newVideo !== currentVideo && !isLoading) {
      setIsLoading(true);
      setCurrentVideo(newVideo);
    }
  }, [currentSection, currentVideo, isLoading]);

  const handleCanPlay = () => {
    setIsLoading(false);
    if (videoRef.current) {
      videoRef.current.play().catch(console.error);
    }
  };

  const handleLoadStart = () => {
    setIsLoading(true);
  };

  const handleError = (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    console.error('Video error:', e);
    setIsLoading(false);
    // Fallback to default video
    if (currentVideo !== 'Shadow OP.mp4') {
      setCurrentVideo('Shadow OP.mp4');
    }
  };

  return (
    <div className="background-video-container">
      <video 
        ref={videoRef}
        className="background-video"
        autoPlay 
        muted 
        loop 
        playsInline
        preload="metadata"
        onCanPlay={handleCanPlay}
        onLoadStart={handleLoadStart}
        onError={handleError}
        key={currentVideo}
      >
        <source src={`/${currentVideo}`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {isLoading && (
        <div className="video-loading">
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default BackgroundVideo;
